// Memoized static data
export const originalStatsData = [
	{ name: 'Total Sales', stat: 'US$ 0', change: '0%', changeType: null },
	{ name: 'Average Order Value', stat: 'US$ 0', change: '0%', changeType: null },
	{ name: 'Conversion Rate', stat: '0%', change: '0%', changeType: null },
	{ name: 'Active Users', stat: '0', change: '0', changeType: null },
	{ name: 'Order Count', stat: '0', change: '0%', changeType: null },
	{ name: 'In-App Revenue', stat: '0%', change: '0%', changeType: null },
	{ name: 'Total Subscribers', stat: '0', change: '0', changeType: null },
	{ name: 'Opt-in Rate', stat: '0%', change: '0%', changeType: null },
];

// Memoized data views config
export const originalDataViewsConfig = [
	{
		title: 'Total Sales', className: 'col-span-2',
		chartMarkers: [{ name: 'Total Sales', color: '#2b7fff' }, { name: 'Refunds/Cancellations', color: '#e7000b' }],
		chartType: 'line',
	},
	{
		title: 'Order Count', className: 'col-span-2 sm:col-span-1',
		chartMarkers: [{ name: 'Order Count', color: '#2b7fff' }], chartType: 'bar',
	},
	{
		title: 'App Launched', className: 'col-span-2 sm:col-span-1',
		chartMarkers: [{ name: 'App Launched', color: '#2b7fff' }], chartType: 'bar',
	},
	{
		title: 'App Installs', className: 'col-span-2 sm:col-span-1',
		chartMarkers: [{ name: 'App Installs', color: '#2b7fff' }], chartType: 'bar',
	},
	{
		title: 'Users by Platform', className: 'col-span-2 sm:col-span-1',
		chartMarkers: [{ name: 'Android', color: '#2b7fff' }, { name: 'iOS', color: '#bedbff' }],
		chartType: 'bar',
	},
	{
		title: 'User Funnel', className: 'col-span-2',
		chartMarkers: [{ name: 'Funnel Stage', color: '#2b7fff' }],
		chartType: 'bar',
	},
]; 